import {observer} from "mobx-react";
import React, {ReactElement} from "react";
import {ExpandComponentProps} from "../../core/grid/component/gridComp";
import {ProjectVersionMaterial} from "../domain/project/projectVersionMaterialDomain";
import MdField from "../../core/metamodel/mdField";
import {ProjectVersionWindow} from "../domain/project/projectVersionWindowDomain";

@observer
export default class ProjectVersionWindowExpandComp extends React.Component<ExpandComponentProps, null> {

  fieldsRow1 : string[] = ['name', 'displacement', 'room']
  fieldsRow2 : string[] = ['reachableOnlyByLadder', 'securityType']
  fieldsRow3 : string[] = ['height', 'width', 'glassArea', 'frameLength']
  fieldsRow4 : string[] = ['angleAlpha', 'angleBeta', 'angleGama', 'angleDelta']
  fieldsRow5 : string[] = ['angleEpsilon', 'angleZetta', 'angleEta', 'angleShadowZ']
  fieldsRow6 : string[] = [ 'frameMaterial', 'frameMaterialWeight']
  fieldsRow7 : string[] = ['glassMaterial', 'glassMaterialWeight']

  fieldRows = [this.fieldsRow1, this.fieldsRow2,this.fieldsRow3,this.fieldsRow4,this.fieldsRow5,this.fieldsRow6,this.fieldsRow7]

  getFormattedValue = (field : MdField) => {
    let window = this.props.item.rowObject as ProjectVersionWindow;
    if (field.fieldName === 'room') {
      return window.room.label;
    }
    if (field.fieldName === 'frameMaterial') {
      return window.frameMaterial.label;
    }
    if (field.fieldName === 'glassMaterial') {
      return window.glassMaterial.label;
    }
    let value = window[field.fieldName];
    if (value === undefined) {
      return "-"
    }
    return field.formatValue(value);
  }

  renderCell = (field : MdField) : ReactElement => {

    return (<div className="fx col-xs-4">
      <div className="item-label" key={field.label}>{field.label}: </div>
      {this.getFormattedValue(field)}
    </div>)
  }

  renderRow = (columnsNames : string[]) : ReactElement => {
    let material = this.props.item.rowObject as ProjectVersionMaterial;
    let fields = material.$mdEntityRef.getFields();
    let cells = []

    for(let column of columnsNames) {
      let field = fields.find(f => f.fieldName === column);
      cells.push(this.renderCell(field))
    }

    return (<div className="row">
      {cells}
    </div>)
  }

  render() {
    let rows = [];
    for (let row of this.fieldRows) {
      rows.push(this.renderRow(row));
    }

    return (
        <div style={{paddingLeft : 25, marginBottom : 25}}>
          {rows}
        </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionWindowExpandComp.tsx